import styled from '@emotion/styled'
import { setCurrentVendor, useAppDispatch } from '@open-tender/cloud'
import { stripTags } from '@open-tender/utils'
import { Body, Box, Button, Heading } from 'components'
import { Clock } from '../../icons'
import { useTheme } from '@emotion/react'

const VendorInfoView = styled(Box)<{ hasBox?: boolean }>`
  width: 90%;
  max-width: 44rem;
  padding: 2rem 2rem 2.5rem;
  ${(props) =>
    props.hasBox ? null : `background-color: ${props.theme.bgColors.primary};`};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: 2rem 2rem 2.5rem;
  }
`

const VendorInfoHeader = styled(Heading)`
  font-size: ${(props) => props.theme.fonts.sizes.xBig};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.big};
  }
`

const VendorInfoDesc = styled(Body)`
  margin: 1rem 0 0;
  font-size: ${(props) => props.theme.fonts.sizes.small};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  }
`

const VendorInfoHours = styled.div`
  margin: 1rem 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const VendorInfoHoursIcon = styled.div`
  position: relative;
  line-height: 0;
  // top: -0.1rem;
  width: 1.6rem;
  height: 1.6rem;
  margin: 0 0.5rem 0 0;
`

const VendorInfoHoursDesc = styled(Body)`
  display: block;
  font-size: ${(props) => props.theme.fonts.sizes.small};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  }
`

const VendorInfoButton = styled.div`
  margin: 1.5rem 0 0;
`
interface VendorInfoProps {
  vendor: any
}

export const VendorInfo = ({ vendor }: VendorInfoProps) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const hasBox = theme.cards.default.bgColor !== 'transparent'
  const { name, description, hours_desc } = vendor
  const hoursDesc = hours_desc ? stripTags(hours_desc) : null
  const desc = description ? stripTags(description) : null

  const switchVendor = () => {
    dispatch(setCurrentVendor(null))
  }

  return (
    <VendorInfoView hasBox={hasBox}>
      <VendorInfoHeader as="p" className="title">
        {name}
      </VendorInfoHeader>
      {desc && <VendorInfoDesc as="p">{desc}</VendorInfoDesc>}
      {hoursDesc && (
        <VendorInfoHours>
          <VendorInfoHoursIcon>
            <Clock />
          </VendorInfoHoursIcon>
          <VendorInfoHoursDesc>{hoursDesc}</VendorInfoHoursDesc>
        </VendorInfoHours>
      )}
      <VendorInfoButton>
        <Button onClick={switchVendor} size="small">
          Switch Vendor
        </Button>
      </VendorInfoButton>
    </VendorInfoView>
  )
}

export default VendorInfo
